import { Pressable, StyleSheet, Text, TextInput } from 'react-native';
import { calcSizeForDevice } from 'utils/index';

import { ProfileSectionItem } from './ProfileSectionItem';

type ProfileNameFieldProps = {
  value: string;
  hasError?: boolean;
  maxLength?: number;
  showCounter?: boolean;
  onChange: (value: string) => void;
  onPress?: () => void;
};

export const ProfileNameField = ({
  value,
  hasError,
  maxLength = 30,
  showCounter = false,
  onChange,
  onPress,
}: ProfileNameFieldProps) => {
  const remaining = maxLength - value.length;

  return (
    <ProfileSectionItem label="Nome do perfil">
      <Pressable accessibilityRole="button" onPress={onPress}>
        <TextInput
          value={value}
          onChangeText={onChange}
          style={[styles.input, hasError && styles.inputError]}
          maxLength={maxLength}
        />
      </Pressable>
      {showCounter && <Text style={styles.counter}>{`${remaining} caracteres restantes`}</Text>}
    </ProfileSectionItem>
  );
};

const styles = StyleSheet.create({
  input: {
    width: '100%',
    height: calcSizeForDevice(56),
    fontSize: calcSizeForDevice(16),
    color: '#FFF',
    backgroundColor: '#070D31',
    borderColor: '#2240FF',
    borderWidth: 2,
    borderRadius: 8,
    paddingHorizontal: calcSizeForDevice(20),
    paddingVertical: calcSizeForDevice(16),
  },
  inputError: {
    borderColor: 'red',
  },
  counter: {
    marginTop: calcSizeForDevice(8),
    alignSelf: 'flex-end',
    color: '#999',
    fontSize: calcSizeForDevice(16),
  },
});
